import { Link } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { Icon } from "../components/Icon";
import { NAV_LINKS } from "../data/links";
import { MARRIAGE_REWARD_ENABLED } from "../data/reward";
import { useLanguageSwitch } from "../hooks/useLanguageSwitch";
import { useMobileMenu } from "../hooks/useMobileMenu";
import { useScrolled } from "../hooks/useScrolled";
import { SectionLink } from "../components/SectionLink";
import { useSiteTranslation } from "../i18n";
import logo from "../../../pictures/home/logo-m.png";
import "../styles/header.css";

export function HomeHeader() {
  const scrolled = useScrolled();
  const [menuOpen, setMenuOpen] = useMobileMenu();
  const { currentUser } = useAuth();
  const { language, setLanguage } = useLanguageSwitch();
  const { t } = useSiteTranslation();
  const account = currentUser ? { to: "/dashboard", label: t("nav.dashboard") } : { to: "/login", label: t("nav.login") };
  const closeMenu = () => setMenuOpen(false);
  const toggleLanguage = () => setLanguage(language === "en" ? "ar" : "en");

  return (
    <>
      <div className="announcement">
        <span>{t("announcement.intent")}</span>
        <i />
        {MARRIAGE_REWARD_ENABLED ? (
          <SectionLink className="announcement-reward" hash="#reward">
            <Icon name="ring" />
            {t("announcement.reward")}
          </SectionLink>
        ) : (
          <strong>{t("announcement.free")}</strong>
        )}
      </div>

      <header className={`header${scrolled ? " scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
        <div className="wrap header-row">
          <SectionLink className="brand" hash="#top" aria-label={t("common.brandHome")}>
            <img src={logo} alt={t("common.logoAlt")} />
          </SectionLink>

          <nav className="desktop-nav" aria-label={t("nav.main")}>
            {NAV_LINKS.map(({ href, label }) => (
              <SectionLink key={href} hash={href}>
                {t(label)}
              </SectionLink>
            ))}
          </nav>

          <div className="header-actions">
            <button
              className="language"
              type="button"
              aria-label={t("nav.switchLanguage")}
              onClick={toggleLanguage}
            >
              <Icon name="globe" />
              <span>{t("nav.languageCode")}</span>
            </button>
            <Link className="login-link" to={account.to}>
              {account.label}
            </Link>
            <SectionLink className="header-cta" hash="#download">
              {t("nav.getApp")} <Icon name="arrow" />
            </SectionLink>
            <button
              className="menu-button"
              type="button"
              aria-label={menuOpen ? t("nav.closeMenu") : t("nav.openMenu")}
              aria-expanded={menuOpen}
              aria-controls="mobile-nav"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      <nav className={`mobile-nav${menuOpen ? " open" : ""}`} id="mobile-nav" aria-label={t("nav.mobile")}>
        <div className="mobile-nav-links">
          {NAV_LINKS.map(({ href, label }) => (
            <SectionLink key={href} hash={href} onClick={closeMenu}>
              {t(label)}
            </SectionLink>
          ))}
          <Link to={account.to} onClick={closeMenu}>
            {account.label}
          </Link>
        </div>
        <div className="mobile-nav-footer">
          <SectionLink className="mobile-download" hash="#download" onClick={closeMenu}>
            {t("nav.downloadApp")}
          </SectionLink>
          <button className="mobile-language" type="button" aria-label={t("nav.switchLanguage")} onClick={toggleLanguage}>
            <Icon name="globe" />
            {/* Each language is named in its own script, so readers of either can find it. */}
            <span lang={language === "en" ? "ar" : "en"}>{language === "en" ? "العربية" : "English"}</span>
          </button>
        </div>
      </nav>
    </>
  );
}
